import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import CustomIconButton from '../../../../../../components/CustomIconButton/CustomIconButton';
import CloseIcon from '../../../../../../components/Icons/CloseIcon';
import RefreshIcon from '../../../../../../components/Icons/RefreshIcon';
import { contratoAssessorAlteraStatus } from '../../../../../../store/modules/ContratosAssessoresActions';
import { getElementID } from '../../../../../../utils/HTMLUtils';
import arquivosStyles from '../Arquivos.scss';

class DesativarButton extends Component {
  isShown = () => {
    return (
      this.props.auth.userPermissions.contratos.assessor.changeStatus &&
      this.props.arquivo.ativo
    );
  };

  changeStatus = () => {
    const arquivo = this.props.arquivo;
    this.props.contratoAssessorAlteraStatus(
      arquivo.id,
      arquivo.versaoContrato,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.successDesativarDocumento,
          options: {
            variant: 'success',
          },
        });
        this.props.refreshStep();
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorDesativarDocumento,
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  onClick = () => {
    this.changeStatus();
  };

  isLoading = () => {
    return this.props.contratosAssessores.loadingAlteraStatus;
  };

  isDisabled = () => {
    const arquivo = this.props.arquivo;
    return this.isLoading() ||
      !arquivo.isLatest ||
      arquivo.idDocAssinado ||
      this.props.contratosAssessores.loadingAlteraArquivo ||
      !this.isShown()
      ? true
      : false;
  };

  render() {
    const arquivo = this.props.arquivo;
    return arquivo && this.isShown() ? (
      <CustomIconButton
        id={getElementID(this.props.id, 'desativar-' + arquivo.id)}
        className={arquivosStyles.rootClassName + '-action-button'}
        onClick={() => this.onClick()}
        tooltipProps={{
          className:
            arquivosStyles.rootClassName + '-action-button-tooltip-caller',
        }}
        size='small'
        tooltip={this.props.languageValues.cadastroContratoArquivosDesativar}
        icon={this.isLoading() ? <RefreshIcon /> : <CloseIcon />}
        theme='pufvYellow'
        disabled={this.isDisabled()}
      />
    ) : null;
  }
}

DesativarButton.propTypes = {
  id: PropTypes.string.isRequired,
  refreshStep: PropTypes.func.isRequired,
  arquivo: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosAssessores: state.contratosAssessores,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      contratoAssessorAlteraStatus,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DesativarButton);
